@let open = isOpen();
@let panelOpen = open && !disablePanel();

<!-- While the panel is open a 10px black strip separates it from the button row, and the
     button's gray tab runs through the strip into the panel — at every width, since the open
     panel always sits right under the button's row. -->
<div class="tw:flex tw:flex-col tw:bg-gray-7">
  <div
    class="tw:flex tw:flex-auto tw:justify-between tw:bg-black tw:max-[744px]:flex-col tw:max-[744px]:gap-2.5"
  >
    <div class="tw:flex tw:gap-[15px]">
      <div class="tw:h-full" [class]="panelOpen ? 'tw:bg-gray-7 tw:pb-2.5' : ''">
        <button
          fr8botUiFiltersButton
          [count]="filtersCount()"
          [active]="open"
          (click)="toggleFilters()"
        >
          {{ 'common.smartFilter.markup.smartFilterButton' | translate }}
        </button>
      </div>

      <div class="tw:flex tw:h-10 tw:items-center tw:empty:hidden">
        <ng-content select="[search]"></ng-content>
      </div>

      <div class="tw:flex tw:h-10 tw:items-center tw:gap-[15px]">
        <span class="tw:typography-body-2 tw:text-gray-3">
          <ng-content select="[results]"></ng-content>
        </span>

        @if (filtersCount()) {
          <button class="link" (click)="clearFilters.emit()">
            <span class="tw:underline">{{
              'common.smartFilter.markup.clearFilters' | translate
            }}</span>
            <fr8bot-ui-icon name="x-1-12" [size]="12" />
          </button>
        }
      </div>
    </div>

    <div
      class="tw:flex tw:h-10 tw:items-center tw:gap-[5px] tw:empty:hidden"
      [class]="open ? 'tw:max-[744px]:hidden' : ''"
    >
      <ng-content select="[table-settings]"></ng-content>
    </div>
  </div>

  @if (panelOpen) {
    <!-- Label | filters | collapse in one row at every width; the filters wrap among themselves.
         The label hides when nothing is projected into it, taking its gap along. -->
    <div class="tw:flex tw:gap-[15px] tw:p-5">
      <div class="tw:flex tw:gap-[15px] tw:empty:hidden">
        <ng-content select="[filters-label]"></ng-content>
      </div>

      <div class="tw:flex tw:min-w-0 tw:flex-1 tw:flex-wrap tw:gap-2.5">
        <ng-content select="[filters]"></ng-content>
      </div>

      <div class="tw:ml-auto tw:flex tw:gap-[15px]">
        <button class="link tw:h-[30px]" (click)="toggleFilters()">
          {{ 'common.smartFilter.markup.collapse' | translate }}
          <fr8bot-ui-icon name="arrow-up-12" [size]="16" />
        </button>
      </div>
    </div>
  }
</div>
